module.exports = __webpack_public_path__ + "img/2.d0fa3c3a.png";